export default __webpack_public_path__ + "static/P-5fd365fcd18c50699f1574d34f263a0f.jpg";